import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Col, Container, Row } from '../../../SPRINTA/atoms/Grid'
import CoverImage from '../../../SPRINTA/atoms/CoverImage'
import FontIcon from '../../../SPRINTA/atoms/FontIcon'
import {Text, Select, FormGroup} from '../../../SPRINTA/atoms/Forms'
import Button from '../../../SPRINTA/atoms/Button'
import PlaceHolder from '../../../SPRINTA/atoms/PlaceHolder'
import Alert from '../../../SPRINTA/atoms/Alert'
import Tag from '../../../SPRINTA/atoms/Tag'
import Loading from '../../../SPRINTA/atoms/Loading'
import CardNumber from '../../Components/CreditCardInput'
import LoadScript from '../../../SPRINTA/helpers/LoadScript'
import { DateISO } from '../../../SPRINTA/helpers/Formatter'
import QRCode from 'qrcode.react'
import TagManager from 'react-gtm-module'

import * as checkout from '../../utils/checkout'
import * as payment from '../../utils/payment'

import utm from '../../utils/utm'

import { numberFormat, date, dateFormat } from '../../../SPRINTA/helpers/Formatter'

import icons from './icons.svg';

import styles from './style.css'

let callback_try = 0



    

class Home extends Component {
  state = {
    paymentMethod: null,
    pixQrCode: false,
    payLocal: false,
    payPass: false,
    payProgram: false,
    pixCopyQrcode:false,
    paymentFull: false,
    loading: false,
    utmData: null,
    token: null,
    loadingCard: false,
    loadingBoleto: false,
    loadingPayAcross: false,
    loadingPix: false,
    loadingPass: false,
    loadingProgram: false,
    loadingLocal: false,
    paymentCardMethod: 'adyen',
    card: {
      name: '',
      number: '',
      cvc: '',
      mount: '',
      year: '',
      installments: 1,
      banner: null
    },
    order: null,
    payment: null,
    products: null,
    passports: null,
    participants: null,
    warnings: [],
    alertCardError: null,
    alertCardSuccess: null,
    alertBoletoError: null,
    alertPassaportError: null,
    alertFirstError: null,
    alertBoletoSuccess: null,
    coupon: '',
    couponLoading: false,
    couponError: null,
    released: 0,
    cupomOpen: false,
    TagManagerGTM: null
  }

  

  


  
  constructor(props) {
    super(props)
    LoadScript('./adyen.encrypt.nodom.min.js', () => {})
  }


  encryptAdyenCard() {
    let key = window.adyen_public_api
    let options = {}

    let cseInstance = window.adyen.encrypt.createEncryption(key, options);
    let encrypt = null;
    let cardData = {
        number : this.state.card.number,
        cvc : this.state.card.cvc,
        holderName : this.state.card.name,
        expiryMonth : this.state.card.mount,
        expiryYear : this.state.card.year,
        generationtime : DateISO()
    };

    encrypt = cseInstance.encrypt(cardData);
    return encrypt
  }

  

  // utms(){
    
    
  //   let utmData = utm.get()
  //   if(utmData){
  //     data = JSON.stringify(utmData.params)
  //   }
  //   console.log(data)
    
  // }

  

  validCardForm(e) {
    e.preventDefault()

    let error = null
    if(this.state.card.number === '' || !this.state.card.number)
      error = 'Preencha o numero do cartão'
    else if(this.state.card.number.length < 16)
      error = 'Preencha o numero do cartão válido'
    else if(this.state.card.name === '' || !this.state.card.name)
      error = 'Preencha o nome no cartão'
    else if(this.state.card.cvc === '' || !this.state.card.cvc)
      error = 'Preencha o cvc do cartão'
    else if(this.state.card.mount === '' || !this.state.card.mount)
      error = 'Preencha o mês de vencimento do cartão'
    else if(this.state.card.year === '' || !this.state.card.year)
      error = 'Preencha o ano de vencimento do cartão'
    else if(!this.state.payment.method.card[this.state.card.banner])
      error = 'Bandeira do cartão ainda não aceita'

    if(error) {
      this.setState({
        alertCardError: error
      })
      return
    }

    this.setState({
      alertCardError: ''
    })

    this.submitPaymentCard()
  }

  submitPaymentCard() {
    let data = {}

    this.setState({
      loadingCard: true,
      alertCardError: null,
      alertCardSuccess: null,
      payment: {
        ...this.state.payment,
        status: 1
      }
    })

    let paymentMethod = this.state.payment.method.card[this.state.card.banner]

    data.band = this.state.card.banner

    if(paymentMethod === 'adyen') {
      data.creditCardEncrypted = this.encryptAdyenCard()
      data.installments = this.state.card.installments
      data.number = this.state.card.number
    } else {
      data = this.state.card
    }
    data.token = this.state.token

    payment.card(data)
    .then(resp => {
      callback_try = 0
      if(resp.errors && resp.errors[0].message) {
        this.setState({
          loadingCard: false,
          alertBoletoError: resp.errors[0].message
        })
        return
      } 
    
      if(resp.status) {
        if(resp.status === 'confirmed') {
          this.setState({
            alertCardSuccess: 'Aguarde um momento, seu pagamento esta sendo processado!',
          })
          this.callbackPaymentStatus(resp.token_log)
        } else if(resp.status === 'processing') {
          this.setState({
            alertCardSuccess: 'Aguarde um momento, seu pagamento esta sendo processado!',
          })
          this.callbackPaymentStatus(resp.token_log)
          
        } else if(resp.status === 'refused') {
          this.setState({
            loadingCard: false,
            alertCardError: 'Pagamento recusado. Verifique os dados'
          })
        }
      }
    })
  }


    payAcross() {
    this.setState({
      loadingPayAcross: true,
    })
    payment.pay_across({ token: this.state.token })
    .then(resp => {
      console.log(resp)
      if(resp.errors && resp.errors[0].message) {
        this.setState({
          loadingBoleto: false,
          alertBoletoError: resp.errors[0].message
        })
        return
      } 
      if(resp.redirect_url)
        window.location.href = resp.redirect_url

      this.setState({
        loadingPayAcross: false,
        pixQrCode: resp.qrCodeResponse.qrCodeData,
      })

      this.callbackTransactionStatus(resp.tid, resp.token_log)
      // this.callbackPaymentStatus(token_log);
      
      
      
    })
  }



  

  payPixRede() {
    this.setState({
      loadingPix: true,
    })
    payment.pixRede({ token: this.state.token })
    .then(resp => {
      console.log(resp)
      if(resp.errors && resp.errors[0].message) {
        this.setState({
          loadingBoleto: false,
          alertBoletoError: resp.errors[0].message
        })
        return
      } 
      if(resp.redirect_url)
        window.location.href = resp.redirect_url

      this.setState({
        loadingPix: false,
        pixQrCode: resp.qrCodeResponse.qrCodeData,
      })

      this.callbackTransactionStatus(resp.tid, resp.token_log)
      // this.callbackPaymentStatus(token_log);
      
      
      
    })
  }


  callbackTransactionStatus(tid, token_log) {
    let prevStatus = this.state.payment.status;
    callback_try = callback_try + 1;
  
    window.setTimeout(() => {
      checkout.getTransactionStatus(tid)
      .then(resp => {
        // Verifica se 'authorization' e 'authorization.status' existem
        if (resp.status === 'confirmed') {
          let status = resp.status;
  
          if (status === 'confirmed') {
            let error = '';
            status = 3;
            this.setState({
              loadingCard: false,
              alertCardError: error,
              alertCardSuccess: "",
              payment: {
                ...this.state.payment,
                status,
              }
            });
          } 
        } else {
          this.callbackTransactionStatus(tid, token_log);
          // this.callbackPaymentStatus(token_log);
      }
      })
      .catch(error => {
        console.error("Error processing the transaction:", error);
        // Trate qualquer erro de chamada de API aqui, como um erro de rede
      });
    }, callback_try * 5000);
  }


  


  
  callbackPaymentStatus(token_log) {
    let prevStatus = this.state.payment.status
    callback_try = callback_try + 1
    window.setTimeout(() => {
      checkout.getTransactionOrderStatus(token_log)
      .then(resp => {
        let status = parseInt(resp.status, 10)
        
        if(status !== prevStatus && status !== 1) {
          let error = ''
          if(status === 0) {
            error = 'Pagamento recusado. Verifique os dados'
          }

          this.setState({
              loadingCard: false,
              alertCardError: error,
              alertCardSuccess: "",
              payment: {
                ...this.state.payment,
                status,
              }
          })
        } else {
          this.callbackPaymentStatus(token_log)
        }
      })
    }, callback_try*5000)
  }

  copyPixCode(){
    navigator.clipboard.writeText(this.state.pixQrCode)

      this.setState({
        pixCopyQrcode: 'Código copiado com sucesso, abra o app do seu banco para efetuar o pagamento.'
      })
    
    
  }


  
 
  
  payPix() {
    this.setState({
      loadingPix: true
    })
    payment.pix({ token: this.state.token })
    .then(resp => {
      if(resp.errors && resp.errors[0].message) {
        this.setState({
          loadingBoleto: false,
          alertBoletoError: resp.errors[0].message
        })
        return
      } 
      if(resp.redirect_url)
        window.location.href = resp.redirect_url

      this.setState({
        loadingPix: false,
        pixQrCode: resp.pix_qr_code
      })
    })
  }

  
  payProgram(program) {
    this.setState({
      loadingProgram: true
    })
    payment.pay_program({ token: this.state.token, program })
    .then(resp => {
     

      if(resp.errors && resp.errors[0].message) {
        
        this.setState({
          loadingProgram: false,
          alertFirstError: resp.errors[0].message
        })
        return
      } 
      this.setState({
        loadingProgram: false,
        payment: resp.payment,
        payProgram:true,
      })
    })
  }

  payFirst() {
    this.setState({
      loadingLocal: true
    })
    payment.free_first({ token: this.state.token })
    .then(resp => {
      console.log(resp)
      if(resp.errors && resp.errors[0].message) {
        this.setState({
          loadingLocal: false,
          alertFirstError: resp.errors[0].message
        })
        return
      }else
      this.setResponsePayment(resp)

      this.setState({
        loadingLocal: false,
        payLocal:true
      })
    })
  }

  payPassport(passaport) {
    this.setState({
      loadingPass: true
    })
    payment.passport({ token: this.state.token, pass: passaport })
    .then(resp => {
      console.log(resp)
      if(resp.errors && resp.errors[0].message) {
        this.setState({
          loadingPass: false,
          alertPassaportError: resp.errors[0].message
        })
        return
      } else
      this.setResponsePayment(resp)
      

      this.setState({
        loadingPass: false,
        // passports:true,
        payPass:true
      })
    })
  }

  payLocal() {
    this.setState({
      loadingLocal: true
    })
    payment.local({ token: this.state.token })
    .then(resp => {
      console.log(resp)
      if(resp.errors && resp.errors[0].message) {
        this.setState({
          loadingBoleto: false,
          alertBoletoError: resp.errors[0].message
        })
        return
      } 

      this.setState({
        loadingLocal: false,
        payLocal:true
      })
    })
  }


  trackMetaPixel(order, eventName = 'PageView', extraData = {}) {
  if (!order || !order.meta_pixel_id || typeof window.fbq !== 'function') {
    return;
  }

  if (!window.__loaded_pixels) {
    window.__loaded_pixels = {};
  }

  if (!window.__tracked_meta_events) {
    window.__tracked_meta_events = {};
  }

  if (!window.__loaded_pixels[order.meta_pixel_id]) {
    console.log('init pixel:', order.meta_pixel_id);
    window.fbq('init', order.meta_pixel_id);
    window.__loaded_pixels[order.meta_pixel_id] = true;
  }

  const dedupeKey = `${eventName}_${order.id || order.title || 'checkout'}`;

  if (
    (eventName === 'PageView' ||
     eventName === 'ViewContent' ||
     eventName === 'InitiateCheckout') &&
    window.__tracked_meta_events[dedupeKey]
  ) {
    return;
  }

  if (eventName === 'PageView') {
    window.fbq('track', 'PageView');
  } else {
    window.fbq('track', eventName, extraData);
  }

  if (
    eventName === 'PageView' ||
    eventName === 'ViewContent' ||
    eventName === 'InitiateCheckout'
  ) {
    window.__tracked_meta_events[dedupeKey] = true;
  }
}


  

  componentWillMount() {
    let token = this.props.match.params.token
    utm.clear()
    utm.capture({
      origin: 'event',
      token: token,
    })

    
    this.setState({
      token,
      utmData: utm.get(),
      loading: true
    })

    

   
  



    checkout.getByToken(token)
    .then(data => {
      if(data.errors && data.errors[0] && data.errors[0].type === 'not_found') {
        window.location.href = window.NOTFOUND
      }

      this.setResponsePayment(data)
    })
  }


    setResponsePayment(data) {
    this.trackMetaPixel(data.order, 'PageView');

    this.trackMetaPixel(data.order, 'ViewContent', {
      content_name: data.order.title || '',
      content_ids: [data.order.id],
      content_type: 'product'
    });

    this.trackMetaPixel(data.order, 'InitiateCheckout', {
      content_name: data.order.title || '',
      content_ids: [data.order.id],
      content_type: 'product',
      value: data.payment && data.payment.amount ? data.payment.amount.total : 0,
      currency: 'BRL'
    });

    if (data.order.owner == 30553 && typeof window.gtag === 'function') {
      window.gtag('config', 'AW-629127483');
      window.gtag('config', 'UA-34507470-2');
      window.gtag('config', 'G-BCCHBF5EGF');
    }

    

  // setResponsePayment(data) {
  //   if(data.order.owner == 30553){
  //     window.fbq('init', '1564726501088368')
  //     window.fbq('track', 'PageView')
  //     window.gtag('config', 'AW-629127483')
  //     window.gtag('config', 'UA-34507470-2')
  //     window.gtag('config', 'G-BCCHBF5EGF')
  // }
      

    if(this.state.utmData != null && this.state.utmData.params ){
        let datautm = {}
        let origin = data.order.type;
        let origin_id = data.order.id;
        datautm.utm = JSON.stringify(this.state.utmData.params)

        checkout.saveUtm(this.state.token, origin, origin_id,  datautm.utm)
        .then(resp => { 
          console.log(resp)
    
        })
    }
    

  
  

    data.payment.status = parseInt(data.payment.status, 10)
    this.setState({
      loading: false,
      order: data.order,
      products: data.products,
      payment: data.payment,
      participants: data.participants,
      released: data.released,
      warnings: data.warnings,
      warningTitle: data.warning_title,
        paymentMethod: this.state.paymentMethod || (data.order.country !== "BR" ? "estrangeiro" : data.payment.method.preference)

    })
  }

  paymentMethod( name ){
     if(name === this.state.paymentMethod)
        name = null

    this.setState(prevState => ({
      paymentMethod: name,
    }));
  }

  handleChangeCard(name, value) {
    let card = this.state.card
    card[name] = value
    this.setState({
      card
    })
  }

  handleChangeCardBanner(banner) {
    this.setState({
      card:{
        ...this.state.card,
        banner
      }
    })
  }

  handleOpenVoucher() {
    let voucher = window.open('about:blank')
    let html = document.getElementById('voucher').innerHTML
    voucher.document.write(html)
  }
  
  handleAddCupom(e) {
    e.preventDefault()
    let error = null
    this.setState({
      couponLoading: true,
      couponError: error
    })

    checkout.addCoupon(this.state.token, this.state.coupon)
    .then(resp => { 
      if(resp.errors && resp.errors[0]) 
        error = 'Cupom não encontrado ou não permitido para esta ação'
      else
        this.setResponsePayment(resp)

      this.setState({
        couponLoading: false,
        couponError: error
      })
    })
  }

  handleChangeCoupom(value) {
    this.setState({
      coupon: value
    })
  }

  cupomToggle() {
    this.setState(state => ({
      cupomOpen: !state.cupomOpen
    }))
  }

  render() {
    const currentYear = (new Date()).getFullYear()
    const years = []


    for (let i = currentYear; i < (currentYear+20); i++) {
      years.push(i)
    }
    if(this.state.loading) {
      return (
        <CoverImage className={styles.bg} image={require('./bg.jpg')}>
          <Container>
            <Row>
              <Col size="12 8" float="center">              
                <PlaceHolder type='retangle' style={{height: '40px', margin: '20px 0', width: '250px'}} />
                <PlaceHolder type='retangle' style={{height: '25px', margin: '20px 0', width: '350px'}} />
                <PlaceHolder type='retangle' style={{height: '300px', margin: '20px 0'}} />
              </Col>
            </Row>
          </Container>
        </CoverImage>
      )
    }

    var total_price = this.state.payment.amount.total

    return (
      <CoverImage className={styles.bg} image={require('./bg.jpg')}>
        <Container>
          <Row>
            <Col size="12 8" float="center" className={styles.headText}>
              <h1>Pagamento</h1>
              <p></p>
            </Col>
            <Col size="12 8" float="center">
              <div className={`${styles.eventBlock} ${styles.clearfix}`}>

                <CoverImage shadow='300' image={this.state.order.cover} className={styles.headerImg}>
                  <Col size="12 10" float="center">
                    <Row>
                      {this.state.order.date && (
                        <div>
                          <Col size="3" text="right" hiddenSM >
                            <p style={{textTransform: 'uppercase'}}>{date(this.state.order.date).month('br').abbrev.toUpperCase()}<br /><span>{date(this.state.order.date).day().int}</span><br />{date(this.state.order.date).year()}</p>
                          </Col>
                          <Col size="3" text="left" hiddenMD hiddenLG>
                              <p style={{textTransform: 'uppercase', fontWeight: 'bold'}}>{dateFormat('d/m/y', this.state.order.date)}</p>
                            
                          </Col>
                        </div>
                      )}
                      <Col size="12 9">
                      
                        <h3>{this.state.order.title}</h3>
                        <p>{this.state.order.location}</p>
                      
                      </Col>
                    </Row>
                  </Col>
                </CoverImage>

                <Col size="12 10" float="center">
                  <div>
                      <Col size="12" className={styles.contentData}>
                        <div style={{cursor: 'pointer'}} className={styles.contentPrice} onClick={() => this.setState({
                              paymentFull: !this.state.paymentFull
                           })}>
                          <Row>
                            <Col size="12 7">
                              <p><b>{this.state.order.name}</b><br />{this.state.order.subtitle}</p>
                            </Col>
                            <Col size="12 5">
                            {this.state.payment.status < 3  && total_price > 0 && (
                              <div>
                              
                                <Col size="12" float="right">
                                  <p className={`${styles.contentPriceTotal}`}>
                                    Total: <b>R${numberFormat(total_price, 2, ',', '.')}</b>
                                  </p>
                                  <p>
                                    {this.state.payment.amount.points > 0 && `ou ${this.state.payment.amount.points} pts`}
                                    {this.state.payment.amount.points > 0 && this.state.payment.amount.non_pointable_amount > 0 && ' + '}
                                    {/* {this.state.payment.amount.non_pointable_amount > 0 && `R$ ${numberFormat(this.state.payment.amount.non_pointable_amount, 2, ',', '.')}`} */}
                                  </p>
                                  
                                </Col>
                                 {this.state.payment.amount.discount > 0 && (
                                  <Col size="12" float="left">
                                    <p style={{ fontSize: '12px' }}>
                                      Você ganhou R$ {numberFormat(this.state.payment.amount.discount, 2, ',', '.')} em descontos. =)
                                    </p>
                                  </Col>
                                )}

                              </div>
                            )}
                            {this.state.payment.status < 3  && total_price == 0 && this.state.payment.amount.points > 0 &&  (
                              <div>
                                <Col size="12" float="right">
                                  <p className={`${styles.contentPriceTotal}`}>
                                    Total: <b>
                                      
                                    {this.state.payment.amount.points > 0 && `${this.state.payment.amount.points} pts`}
                                    {this.state.payment.amount.points > 0 && this.state.payment.amount.non_pointable_amount > 0 && ' + '}
                                    {this.state.payment.amount.non_pointable_amount > 0 && `R$ ${numberFormat(this.state.payment.amount.non_pointable_amount, 2, ',', '.')}`}


                                    



                                    </b>
                                  </p>
                                 
                                </Col>
                              </div>
                            )}
                              <FontIcon name={this.state.paymentFull ? 'up-arrow' : 'down-arrow'} color="#ff5500"/>
                            </Col>
                            
                          </Row>
                        </div>

                        <div className={`${this.state.paymentFull ? styles.opened : ''} ${styles.boxCollapse} ${styles.contentPaymentOpen}`}>
                          {this.state.products && this.state.products.itens.length > 0 && (
                            <div className={styles.kitItems}>
                              <p className={styles.kitDataLeft}>Compras extras</p>
                              {this.state.products.itens.map(product => (
                                <div key={product.product.id_extra} className={styles.kitItem}>
                                  <Row>
                                    <Col size="12 8" text="left">
                                      <div className={styles.photoItem}>
                                        <img src={product.product.image} width="85px" alt={`Imagem de ${product.product.description}`}/>
                                        <p  style={{ margin: 0 }}><b>{product.product.description}</b><br />{product.product.options_name} {product.product.label}</p>
                                      </div>
                                    </Col>
                                    <Col size="6 1" text="center right" style={{paddingTop:'10px'}}>
                                      <p>{product.product.qtdy}</p>
                                    </Col>
                                    <Col size="6 3" text="center right" style={{paddingTop:'10px'}}>
                                    {this.state.payment.status < 3  && (
                                      <p>
                                      {product.product.amount_total > 0 && `R$ ${numberFormat(product.product.amount_total, 2, ',', '.')}`}
                                      {product.product.amount_total > 0 && product.product.required_points > 0 && <br />}
                                      {product.product.required_points > 0 && `${product.product.required_points} pts`}
                                      </p>
                                    
                                      
                                    )}
                                    </Col>
                                  </Row>
                                </div>
                              ))}

                            </div>
                          )}

                          <div className={styles.kitData}>
                            <ul>
                              <li className={styles.clearfix}>
                                <p className={styles.kitDataLeft}>Inscrição ({this.state.participants.count})</p>
                                {this.state.payment.status < 3  && (
                                <p className={styles.kitDataRight}>R$ {numberFormat(this.state.payment.amount.inscription, 2, ',', '.')}</p>
                                )}
                                <div style={{ maxHeight: '400px', overflow: 'auto', width: '100%' }}>
                                  {this.state.participants.users.map(user => (
                                    <div key={user.athlete_name} style={{width: '100%', float: 'left', marginBottom: '15px', backgroundColor: '#efefef', fontSize: '14px', padding: '8px', fontWeight: 'bold', color: '#666'}}>
                                      {user.athlete_name} <br />
                                      <small>{user.category}</small>
                                      <small> - {user.name}</small>
                                    </div>
                                  ))}
                                </div>
                              </li>
                              {this.state.products && this.state.products.itens.length > 0 && (
                                <li className={styles.clearfix}>
                                  <p className={styles.kitDataLeft}>Itens Adicionais ({this.state.products.itens.length})</p>
                                  <p className={styles.kitDataRight}>R$ {numberFormat(this.state.payment.amount.products, 2, ',', '.')}</p>
                                </li>
                              )}

                              <li className={styles.clearfix}>
                                  <p className={styles.kitDataLeft}>
                                    Descontos
                                    {this.state.payment.coupon && (
                                      <div>
                                        <small>
                                          {this.state.payment.coupon.code}
                                        </small>
                                      </div>
                                    )}
                                  </p>
                                  <p className={styles.kitDataRight}>R$ {numberFormat(this.state.payment.amount.discount, 2, ',', '.')}</p>
                              </li>
                              {this.state.payment.status < 3  && (
                              <li className={styles.clearfix}>
                                <p className={styles.kitDataLeft}>Taxas e impostos</p>
                                <p className={styles.kitDataRight}>R$ {numberFormat(this.state.payment.amount.convenience, 2, ',', '.')}</p>
                              </li>
                              )}
                              {this.state.payment.status < 3  && (
                              <p className={`${styles.contentPriceTotal} ${'clearfix'}`} style={{marginTop:'10px', textAlign:'right', float:'initial', }}>
                                Total: <b>
                                <p>
                                {total_price > 0 && this.state.payment.amount.points > 0 ? (
                                  <span>R$ {numberFormat(total_price, 2, ',', '.')} ou {this.state.payment.amount.points} pts</span>
                                ) : (
                                  <span>
                                    {total_price > 0 && `R$ ${numberFormat(total_price, 2, ',', '.')}`}
                                    {total_price > 0 && this.state.payment.amount.points > 0 && <br />}
                                    {this.state.payment.amount.points > 0 && `${this.state.payment.amount.points} pts`}
                                  </span>
                                )}
                              </p>


                                </b>
                                </p>
                              )}
                            </ul>
                          </div>
                        </div>
                        {!this.state.payment.coupon && this.state.payment.status < 3  && (
                          <div>
                            <div className={styles.contentCupom} style={{cursor: 'pointer'}} onClick={() => this.cupomToggle()}>
                              <FontIcon name="cupon" />
                              <p>Adicionar cupom de desconto</p>
                              <div style={{float: 'right'}}>
                                <FontIcon size={9} style={{marginRight: 0, position: 'relative', right: '-14px' }} name={this.state.cupomOpen ? 'up-arrow' : 'down-arrow'}/>
                              </div>
                            </div>
                            <form onSubmit={(e) => this.handleAddCupom(e)} className={`${styles.contentCupomOpen} ${styles.boxCollapse} ${this.state.cupomOpen ? styles.opened : ''}`}>
                              <Row gutter='small'>
                                {this.state.couponError && (
                                  <Col>
                                    <Alert type='danger'>{this.state.couponError}</Alert>
                                  </Col>
                                )}
                                <Col size="12 8">
                                  <FormGroup>
                                      <Text
                                        placeholder="Digite o código promocional"
                                        value={this.state.coupon}
                                        handleChange={e => this.handleChangeCoupom(e.target.value)}
                                      ></Text>
                                  </FormGroup>
                                </Col>
                                <Col size="12 4">
                                  <FormGroup>
                                    {this.state.couponLoading ? (
                                      <Loading />
                                    ) : (
                                      <Button theme="primary">Aplicar Cupom</Button>
                                    )}
                                  </FormGroup>
                                </Col>
                                
                              </Row>
                            </form>
                          </div>
                        )}
                      </Col>
                  </div>
                </Col>
              </div>
            </Col>
            
            {this.state.payment.status > 2 && (
              <Col size="12 8" float="center" text="center" style={{marginBottom: '12px'}}>
                  <div className={`${styles.paymentBlock} ${styles.clearfix}`}>
                    <h1>Atividade <b>confirmada</b></h1>
                    <a href={`/voucher/${this.state.token}`} target="_blanck">
                      <Button theme='primary' inline>Imprimir voucher</Button>
                    </a>
                  </div>
              </Col>
            )}

            {this.state.warnings.length && (
              <Col size="12 8" float="center" text="left" style={{marginBottom: '12px'}}>
                  <div className={`${styles.paymentBlock} ${styles.clearfix}`}>

                    <Col size="12 10" float="center">
                      <Row>
                        <Col>
                          <h1 style={{textAlign: 'left'}}>{this.state.warningTitle}</h1>
                        </Col>
                        {this.state.warnings.map((warning, key) => (
                          <Col key={key} style={{marginBottom: '10px'}}>
                            <Alert type="warning">{warning}</Alert>
                          </Col>
                        ))}
                      </Row>
                    </Col>

                  </div>
              </Col>
            )}


            {((!this.state.payment.method.boleto && !this.state.order.programs_accept && !this.state.payment.method.local && !this.state.payment.method.card) || !this.state.released || this.state.payment.status > 2) ? (
              <div />
            ) : (
              
            <Col size="12 8" float="center">
              <div className={`${styles.paymentBlock} ${styles.clearfix}`}>
                <Col size="12 10" float="center">
                  <h1>Selecione a <b>forma de pagamento</b></h1>

                  {!["BRA", "BR"].includes(this.state.order.country) && (

                  <div className={styles.contentPrice} style={{marginBottom:'5px'}}>
                     <div onClick={() => this.paymentMethod('estrangeiro')} style={{
                           cursor: 'pointer'
                        }}>
                       <Row>
                         <Col size="10 11">
                           <FontIcon name="admin_web" color="" size={25} style={{marginRight:'20px', marginTop:'0'}}/>
                           <p>International payment</p>
                         </Col>
                         <Col size="2 1">
                           <FontIcon name={this.state.paymentMethod === 'estrangeiro' ? 'up-arrow' : 'down-arrow'} color="#ff5500"/>
                         </Col>
                      </Row>
                     </div>
                   <Row>
                      <Col size="12" className={`${styles.boxCollapse} ${this.state.paymentMethod === 'estrangeiro' ? styles.opened : ''}`}>
                        <Col size='12'>
                          {this.state.alertBoletoError && (
                            <Alert type='danger'>{this.state.alertBoletoError}</Alert>
                          )}
                          {this.state.alertBoletoSuccess && (
                            <Alert type='success'>{this.state.alertBoletoSuccess}</Alert>
                          )}
                        </Col>

                         {this.state.loadingPayAcross ? (
                          <div>
                          <Loading />
                          <p>You will be redirected to the international payment page.</p>
                          </div>
                        ) : (
                         <Button style={{marginTop:'20px'}} theme="primary" onClick={() => this.payAcross()}>Pay Now</Button>
                        )}

                        
                       
                      </Col>
                   </Row>
                  </div>
                )}
                
                {this.state.payment.method.boleto && (

                  <div className={styles.contentPrice} style={{marginBottom:'5px'}}>
                     <div onClick={() => this.paymentMethod('boleto')} style={{
                           cursor: 'pointer'
                        }}>
                       <Row>
                         <Col size="10 11">
                           <FontIcon name="boleto" color="" size={25} style={{marginRight:'20px', marginTop:'0'}}/>
                           <p>Boleto</p>
                         </Col>
                         <Col size="2 1">
                           <FontIcon name={this.state.paymentMethod === 'boleto' ? 'up-arrow' : 'down-arrow'} color="#ff5500"/>
                         </Col>
                      </Row>
                     </div>
                   <Row>
                      <Col size="12" className={`${styles.boxCollapse} ${this.state.paymentMethod === 'boleto' ? styles.opened : ''}`}>
                        <Col size='12'>
                          {this.state.alertBoletoError && (
                            <Alert type='danger'>{this.state.alertBoletoError}</Alert>
                          )}
                          {this.state.alertBoletoSuccess && (
                            <Alert type='success'>{this.state.alertBoletoSuccess}</Alert>
                          )}
                        </Col>
                        <a href={`${window.link_boleto}${this.state.token}`} target="_blank">
                          <Button style={{marginTop:'20px'}} theme="primary">Emitir Boleto</Button>
                        </a>
                        
                        {/* {this.state.loadingBoleto ? (
                          <Loading />
                        ) : (
                          <Button style={{marginTop:'20px'}} theme="primary" onClick={() => this.payBoleto()}>Emitir Boleto</Button>
                        )} */}
                      </Col>
                   </Row>
                  </div>
                )}
                      
                {this.state.payment.method.card && !this.state.payLocal && this.state.participants.allow_pay_installment > 0 &&  (
                  <div className={styles.contentPrice} style={{marginBottom:'5px'}}>
                     <div style={{cursor: 'pointer'}} onClick={() => this.paymentMethod('card')}>
                       <Row>
                         <Col size="10 11">
                           <FontIcon name="card" color="" size={25} style={{marginRight:'20px', marginTop:'0'}}/>
                           <p>Cartão de Crédito</p>
                           {/* <div style={{fontSize: '12px', size: '30px',  marginTop: '15px'}}>
                            Pagando com este método, você está protegido contra acidentes pessoais e acumula 10 pontos no fidelidade.
                            </div> */}
                         </Col>
                         <Col size="2 1">
                           <FontIcon name={this.state.paymentMethod === 'card' ? 'up-arrow' : 'down-arrow'} color="#ff5500"/>
                         </Col>
                      </Row>
                     </div>
                      <Row>
                        <Col size="12 12" className={`${styles.boxCollapse} ${this.state.paymentMethod === 'card' ? styles.opened : ''}`}>
                          <form onSubmit={(e) => this.validCardForm(e)} id='credit-card-form'>
                            <Row gutter='small'>
                              <Col size="12">
                                 <FormGroup>
                                    <CardNumber
                                      value={this.state.card.number}
                                      handleChange={e => this.handleChangeCard('number', e.target.value)}
                                      handleChangeCardBanner={banner => this.handleChangeCardBanner(banner)}
                                      placeholder="Número do cartão" />
                                 </FormGroup>
                              </Col>
                              <Col size="12 6">
                                 <FormGroup>
                                    <Text
                                      value={this.state.card.name}
                                      handleChange={e => this.handleChangeCard('name', e.target.value)}
                                      placeholder="Nome no cartão" />
                                 </FormGroup>
                              </Col>
                              
                              <Col size="12 3">
                                 <FormGroup>
                                   <Select
                                    value={this.state.card.mount}
                                    handleChange={e => this.handleChangeCard('mount', e.target.value)}
                                   >
                                     <option value=''>Mês</option>
                                     <option value='01'>01</option>
                                     <option value='02'>02</option>
                                     <option value='03'>03</option>
                                     <option value='04'>04</option>
                                     <option value='05'>05</option>
                                     <option value='06'>06</option>
                                     <option value='07'>07</option>
                                     <option value='08'>08</option>
                                     <option value='09'>09</option>
                                     <option value='10'>10</option>
                                     <option value='11'>11</option>
                                     <option value='12'>12</option>
                                   </Select>
                                </FormGroup>
                              </Col>
                              <Col size="12 3">
                                 <FormGroup>
                                   <Select
                                    value={this.state.card.year}
                                    handleChange={e => this.handleChangeCard('year', e.target.value)}
                                   >
                                      <option>Ano</option>
                                      {years.map(item => (
                                        <option value={item} key={item}>{item}</option>
                                      ))}
                                    </Select>
                                 </FormGroup>
                              </Col>
                              <Col size="12 5">
                                 <FormGroup>
                                    <Text
                                    value={this.state.card.cvc}
                                    handleChange={e => this.handleChangeCard('cvc', e.target.value)}
                                    mask='####' placeholder="Código de segurança" />
                                 </FormGroup>
                              </Col>
                              <Col size="7" style={{display: 'none'}}>
                                 <FormGroup>
                                    <p className={styles.codigo}>
                                       <span className={styles.interrogacao_icon}>?</span>
                                       Veja onde encontrar o<br />código de segurança
                                    </p>
                                 </FormGroup>
                              </Col>
                              <Col size="12">
                                 <FormGroup>
                                   <Select
                                    value={this.state.card.installments}
                                    handleChange={e => this.handleChangeCard('installments', e.target.value)}
                                   >
                                    {this.state.payment.installment.map(item => (
                                      <option key={item.installment} value={item.installment}>{item.installment}x de R${numberFormat(item.amount, 2, ',', '.')}</option>
                                    ))}
                                   </Select>
                                 </FormGroup>
                              </Col>
                              <input type='hidden' value={DateISO()} data-encrypted-name="generationtime" />

                              <Col size='12'>
                                {this.state.alertCardError && (
                                  <Alert type='danger'>{this.state.alertCardError}</Alert>
                                )}
                                {this.state.alertCardSuccess && (
                                  <Alert type='neutral'>{this.state.alertCardSuccess}</Alert>
                                )}
                              </Col>

                              <Col size="12" text='right'>
                                <FontIcon name="" color="#ff5500"/>
                                {this.state.loadingCard ? (
                                  <Col size=' 12 4' float='right'>
                                    <Row>
                                      <Loading />
                                    </Row>
                                  </Col>
                                ) : (
                                  <Button theme="primary" inline>Finalizar Pagamento</Button>
                                )}
                              </Col>
                            </Row>
                          </form>
                        </Col>
                    </Row>
                  </div>
                )}

{this.state.payment.method.pix &&(

<div className={styles.contentPrice} style={{ marginBottom: '5px' }}>
  <div onClick={() => this.paymentMethod('pix')} style={{
    cursor: 'pointer'
  }}>
    <Row>
      <Col size="10 11">
        <FontIcon name="pix" color="" size={25} style={{ marginRight: '20px', marginTop: '0' }} />
        <p>Pix</p>
        {/* <div style={{fontSize: '12px', size: '30px',  marginTop: '15px'}}>
            Pagando com este método, você está protegido contra acidentes pessoais e acumula 10 pontos no fidelidade.
        </div> */}
      </Col>
      <Col size="2 1">
        <FontIcon name={this.state.paymentMethod === 'pix' ? 'up-arrow' : 'down-arrow'} color="#ff5500" />
      </Col>
    </Row>
  </div>
  <Row>
    <Col size="12" className={`${styles.boxCollapse} ${this.state.paymentMethod === 'pix' ? styles.opened : ''}`}>
      <Col size='12'>
        {this.state.alertBoletoError && (
          <Alert type='danger'>{this.state.alertBoletoError}</Alert>
        )}
        {this.state.alertBoletoSuccess && (
          <Alert type='success'>{this.state.alertBoletoSuccess}</Alert>
        )}
      </Col>

      {this.state.loadingPix ? (
        <Loading />
      ) : (
          ''
        )} 
        
        {this.state.pixQrCode ? (
            <div>
              <center>
              <QRCode value={this.state.pixQrCode} size={150} />
              </center>
              <div  style={{marginTop:'20px'}}>
              <div style={{ fontSize: '12px'}} >
              <center>
                 <div style={{cursor:'pointer'}}  onClick={() => this.copyPixCode()}>Copiar código para pagamento</div>
               </center>
              
              {this.state.pixCopyQrcode ? (
                <div style={{marginTop:'10px'}} >
                  <Alert type="warning" > <center>{this.state.pixCopyQrcode}</center></Alert>
                 </div>
              ):(
                ''
              )}
              
              </div>
              
              </div>
              <div  style={{marginTop:'20px'}}>
                <Alert type='danger'>
                  Atenção! 
                  Você tem 60 minutos para completar seu pagamento via PIX. 
                  Após pagamento, aguarde nosso e-mail de confirmação.
                  </Alert>
                  </div>
            </div>
              
            ) : (
              <Button style={{marginTop:'20px'}} theme="primary" onClick={() => this.payPixRede()}>Gerar QRCODE do PIX</Button>
            )}

    </Col>
  </Row>
</div>

)}



{this.state.payment.method.local && (
<div className={styles.contentPrice} style={{ marginBottom: '5px' }}>
  <div onClick={() => this.paymentMethod('local')} style={{
    cursor: 'pointer'
  }}>
    <Row>
      <Col size="10 11">
        <FontIcon name="user_money" color="" size={25} style={{ marginRight: '20px', marginTop: '0' }} />
        <p>Agendar pagamento no local</p>
      </Col>
      <Col size="2 1">
        <FontIcon name={this.state.paymentMethod === 'local' ? 'up-arrow' : 'down-arrow'} color="#ff5500" />
      </Col>
    </Row>
  </div>
  <Row>
    <Col size="12" className={`${styles.boxCollapse} ${this.state.paymentMethod === 'local' ? styles.opened : ''}`}>
      <Col size='12'>
        {this.state.alertBoletoError && (
          <Alert type='danger'>{this.state.alertBoletoError}</Alert>
        )}
        {this.state.alertBoletoSuccess && (
          <Alert type='success'>{this.state.alertBoletoSuccess}</Alert>
        )}
      </Col>  
        {this.state.payLocal ? (
              <div  style={{marginTop:'20px'}}>
                <Alert type='success'>
                  Agendamento confirmado, mas atenção! <br />
                  Você deverá efetuar o pagamento diretamente no estabelecimento no dia das sua experiência!<br />
                  <br />
                  Aproveite fale com o organizador via whats'app para avisar do seu agendamento.
                  </Alert>
                  <a href={`https://wa.me/5551991874747?text=Olá!%20acabei%20de%20agendar%20uma%20experiência%20pelo%20SPRINTA%20-%20${this.state.order.title}`} target="_blanck">
                  <Button style={{marginTop:'20px'}} theme="secondary">Entrar em contato via What's APP</Button>
                  </a>
                  </div>
            ) : (
              <div>
                {this.state.loadingLocal ? (
                   <Loading />
                    ) : (
                      <div>
                        <div style={{fontSize: '12px', size: '30px',  marginTop: '15px'}}>
                              <center>Você deverá efetuar o pagamento no local no dia da atividade</center>
                        </div>    
                      <Button style={{marginTop:'20px'}} theme="primary" onClick={() => this.payLocal()}>Confirmar pagamento no local</Button>
                      </div>
                    )} 
              </div>
            )}
    </Col>
  </Row>
</div>
)}
{this.state.payment.method.free && (

<div className={styles.contentPrice} style={{ marginBottom: '5px' }}>
  <div onClick={() => this.paymentMethod('free')} style={{
    cursor: 'pointer'
  }}>
    <Row>
      <Col size="10 11">
        <FontIcon name="sprinta-chalenges" color="" size={25} style={{ marginRight: '20px', marginTop: '0' }} />
       <icons />
        <p>Aproveite uma aula grátis</p>
      </Col>
      <Col size="2 1">
        <FontIcon name={this.state.paymentMethod === 'free' ? 'up-arrow' : 'down-arrow'} color="#ff5500" />
      </Col>
    </Row>
  </div>
  <Row>
    <Col size="12" className={`${styles.boxCollapse} ${this.state.paymentMethod === 'free' ? styles.opened : ''}`}>
      
        {this.state.payLocal ? (
              <div  style={{marginTop:'20px'}}>
                <Alert type='success'>
                  Agendamento confirmado com sucesso! <br />
                  Sua atividade será grátis, você não precisará pagar nada no local!<br />
                  <br />
                  Aproveite fale com o organizador via whats'app para avisar do seu agendamento.
                  </Alert>
                  <a href={`https://wa.me/5551991874747?text=Olá!%20acabei%20de%20agendar%20uma%20experiência%20pelo%20SPRINTA%20-%20${this.state.order.title}`} target="_blanck">
                  <Button style={{marginTop:'20px'}} theme="secondary">Entrar em contato via What's APP</Button>
                  </a>
                  </div>
            ) : (
              <div>
                   
                {this.state.loadingLocal ? (
                   <Loading />
                    ) : (
                      <div >
                          {this.state.alertFirstError ? (
                            <div style={{fontSize: '12px', size: '30px',  marginTop: '15px'}}>
                              <Alert type='danger'><center>{this.state.alertFirstError}</center></Alert>
                            </div>
                          ) : (
                            <div style={{fontSize: '12px', size: '30px',  marginTop: '15px'}}>
                              <center>Oba! Você pode fazer uma aula grátis para testar essa atividade!</center>
                              <Button style={{marginTop:'20px'}} theme="primary" onClick={() => this.payFirst()}>Utilizar bônus</Button>
                          </div>
                          )}
                      </div>
                    )} 
              </div>
            )}
    </Col>
  </Row>
</div>
)}


{this.state.payment.amount.points > 0  && (
  <div className={styles.contentPrice} style={{ marginBottom: '5px' }}>
    <div onClick={() => this.paymentMethod('program')} style={{
      cursor: 'pointer'
    }}>
      <Row>
        <Col size="10 11">
          <FontIcon name="sprinta-chalenges" color="" size={25} style={{ marginRight: '20px', marginTop: '0' }} />
        <icons />
        <p>
          {this.state.payment.amount.points > 0 && `Pague com pontos ${this.state.payment.amount.points} pts`}
          {this.state.payment.amount.points > 0 && this.state.payment.amount.non_pointable_amount > 0 && ' + '}
          {this.state.payment.amount.non_pointable_amount > 0 && `R$ ${numberFormat(this.state.payment.amount.non_pointable_amount, 2, ',', '.')}`}
        </p>

        </Col>
        <Col size="2 1">
          <FontIcon name={this.state.paymentMethod === 'program' ? 'up-arrow' : 'down-arrow'} color="#ff5500" />
        </Col>
      </Row>
    </div>
    <Row>
      <Col size="12" className={`${styles.boxCollapse} ${this.state.paymentMethod === 'program' ? styles.opened : ''}`}>
        
          {this.state.payProgram ? (
                <div  style={{marginTop:'20px'}}>
                  <Alert type='success'>
                    Agendamento confirmado com sucesso! <br />
                    Sua atividade será grátis, você não precisará pagar nada no local!<br />
                    <br />
                    Aproveite fale com o organizador via whats'app para avisar do seu agendamento.
                    </Alert>
                    <a href={`https://wa.me/5551991874747?text=Olá!%20acabei%20de%20agendar%20uma%20experiência%20pelo%20SPRINTA%20-%20${this.state.order.title}`} target="_blanck">
                    <Button style={{marginTop:'20px'}} theme="secondary">Entrar em contato via What's APP</Button>
                    </a>
                    </div>
              ) : (
                <div>
                    
                  {this.state.payProgram ? (
                    <Loading />
                      ) : (
                        <div >
                            {this.state.alertFirstError ? (
                              <div style={{fontSize: '12px', size: '30px',  marginTop: '15px'}}>
                                <Alert type='danger'><center>{this.state.alertFirstError}</center></Alert>
                              </div>
                            ) : (
                              <div style={{fontSize: '12px', size: '30px',  marginTop: '15px'}}>
                              {
                                this.state.order.programs_accept && this.state.order.programs_accept.length > 0 &&
                                this.state.order.programs_accept.map(program => (
                                    <Col size="12" key={program.id} text='left' style={{ marginTop: '10px', marginBottom: '10px' }}>
                                        <Col size='2' float='left'>
                                            <img src={program.image} alt={program.name} style={{ width: '50px', height: '50px', borderRadius: '50px' }} />
                                        </Col>
                                        <Col size='10' float='left'>
                                        <p style={{ fontSize: '14px' }}><b>{program.name}</b></p>
                                            <div style={{ fontSize: '12px' }}>

                                                {/* {program.description} */}
                                                <b>{program.points > 0 && `Seus pontos disponíveis: ${program.total_user_points} pts.`} <br /></b>
                                              <b> {program.total_user_points < this.state.payment.amount.points && `Você precisa acumular mais ${this.state.payment.amount.points - program.total_user_points} pts para resgatar nessa compra.`}</b>
                                            </div>
                                        </Col>
                                        
                                        <Col size='2' float='right'>
                                        {this.state.loadingProgram ? (
                                                <Loading />
                                            ) : (
                                              program.total_user_points > 0 && program.total_user_points >= this.state.payment.amount.points && (
                                                    <Button theme="primary" inline onClick={() => this.payProgram(program.program_id)}>Utilizar</Button>
                                                )
                                            )}

                                        </Col>
                                    </Col>
                                ))
                              }                
                              </div>
                            )}
                        </div>
                      )} 
                </div>
              )}
      </Col>
    </Row>
  </div>
)}

{this.state.payment.method.passports && (
<div className={styles.contentPrice} style={{ marginBottom: '5px' }}>
  <div onClick={() => this.paymentMethod('passport')} style={{
    cursor: 'pointer'
  }}>
    <Row>
      <Col size="10 11">
        <FontIcon name="user_finance" color="" size={25} style={{ marginRight: '20px', marginTop: '0' }} />
       <icons />
        <p>Passaportes</p>
      </Col>
      <Col size="2 1">
        <FontIcon name={this.state.paymentMethod === 'passport' ? 'up-arrow' : 'down-arrow'} color="#ff5500" />
      </Col>
    </Row>
  </div>
  <Row>
    <Col size="12" className={`${styles.boxCollapse} ${this.state.paymentMethod === 'passport' ? styles.opened : ''}`}>  
        {this.state.payPass ? (
              <div  style={{marginTop:'20px'}}>
                <Alert type='success'>
                  Passaporte utilizado com sucesso e benefício aplicado! Se a sua inscrição não foi confirmada, efetue o pagamento da diferença. <br />
                  </Alert>
                  </div>
            ) : (
              <div>
                {this.state.loadingPass ? (
                   <Loading />
                    ) : (
                      <div>
                        {this.state.alertPassaportError && (
                            <div style={{marginTop:'20px'}}>
                              <Alert type='danger'>{this.state.alertPassaportError}</Alert>
                            </div>
                          )}

                        {this.state.payment.method.passports.map(passport => (
                            <Col size="12" key={passport.pass} text='left' style={{marginTop:'10px', marginBottom:'10px'}}> 
                              <Col size=' 12 10' float='left'>
                                <p style={{fontSize: '14px'}}><b>{passport.name}</b></p>
                                <div style={{fontSize: '12px'}}>
                                {passport.description}
                                {passport.inscription > 0 && `. Neste evento, você tem ${passport.inscription}% de desconto na inscrição`}
                                {passport.inscription > 0 && passport.products > 0 && ' e '}
                                {passport.products > 0 && ` ${passport.products}% nos produtos`}
                                {(passport.inscription > 0 || passport.products > 0) && '.'}



                              </div>   
                              </Col>
                              <Col size=' 12 2' float='right'>
                                <Button theme="primary" inline onClick={() => this.payPassport(passport.pass)}>Utilizar </Button>
                              </Col>
                              <Col size=' 12 12' float='left'>
                              </Col>
                              </Col>
                            ))}
                          
                          
                      </div>
                    )} 
              </div>
            )}
    </Col>
  </Row>
</div>
)}

{this.state.payment.prime && this.state.payment.prime.user_extract && (

<div className={styles.contentPrice} style={{ marginBottom: '5px' }}>
  <div onClick={() => this.paymentMethod('points')} style={{
    cursor: 'pointer'
  }}>
    <Row>
      <Col size="10 11">
        <FontIcon name="thumbs" color="" size={25} style={{ marginRight: '20px', marginTop: '0' }} />
       <icons />
        <p>Utilizar pontos e cashback ( {this.state.payment.prime.user_extract.total_cashback_available} pts ) </p>
      </Col>
      <Col size="2 1">
        <FontIcon name={this.state.paymentMethod === 'free' ? 'up-arrow' : 'down-arrow'} color="#ff5500" />
      </Col>
    </Row>
  </div>
  <Row>
    <Col size="12" className={`${styles.boxCollapse} ${this.state.paymentMethod === 'points' ? styles.opened : ''}`}>
      
        {this.state.payLocal ? (
              <div  style={{marginTop:'20px'}}>
                <Alert type='success'>
                  Agendamento confirmado, mas atenção! <br />
                  Você deverá efetuar o pagamento diretamente no estabelecimento no dia das sua experiência!<br />
                  <br />
                  Aproveite fale com o organizador via whats'app para avisar do seu agendamento.
                  </Alert>
                  <a href={`https://wa.me/5551991874747?text=Olá!%20acabei%20de%20agendar%20uma%20experiência%20pelo%20SPRINTA%20-%20${this.state.order.title}`} target="_blanck">
                  <Button style={{marginTop:'20px'}} theme="secondary">Entrar em contato via What's APP</Button>
                  </a>
                  </div>
            ) : (
              <div>
                {this.state.loadingLocal ? (
                   <Loading />
                    ) : (
                      <div>
                         <div style={{fontSize: '12px', size: '30px',  marginTop: '15px'}}>
                              <center>Neste evento você pode trocar 100 pontos por R$ 10,00 de desconto</center>
                          </div>    
                        <Button style={{marginTop:'20px'}} theme="primary" onClick={() => this.payPoints()}>Utilizar pontos</Button>
                      </div>
                    )} 
              </div>
            )}
    </Col>
  </Row>
</div>
)}




                </Col>
              </div>
            </Col>
            )}

          </Row>
        </Container>

      </CoverImage>
    )
  }
}


const mapStateToProps = store => ({})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Home)



// WEBPACK FOOTER //
// ./src/App/pages/Home/index.js